import { combineReducers } from "redux";
import { getHistory } from "@claroty/utilities/store/history";
import { connectRouter } from "connected-react-router";
import * as preAuthActionTypes from "../actions/PreAuthActions/preAuthActionTypes";
import { PRE_AUTH_LOCAL_STORAGE_KEYS, Theme } from "../const/preAuthConsts";
import preAuthRoutes from "../components/routes/preAuthRoutes";
import { PRE_AUTH_INITIAL_STATE } from "./preAuthInitialState";

const INITIAL_STATE_WITH_ROUTES = {
    ...PRE_AUTH_INITIAL_STATE,
    routes: {
        ...PRE_AUTH_INITIAL_STATE.routes,
        pageRoutes: preAuthRoutes,
    },
};

export default function preAuthReducer(state = INITIAL_STATE_WITH_ROUTES, action) {
    switch (action.type) {
        // pre auth state
        case preAuthActionTypes.SET_IS_AUTHENTICATED:
            return Object.assign({}, state, {
                isAuthenticated: action.isAuthenticated,
            });
        case preAuthActionTypes.SET_USERNAME:
            return Object.assign({}, state, {
                username: action.username,
            });
        case preAuthActionTypes.CURRENTLY_LOADING:
            return Object.assign({}, state, {
                loading: action.currentlyLoading,
            });

        // other states cloned here for use pre-auth
        case preAuthActionTypes.SET_DARK_MODE:
            document.documentElement.dataset.theme = action.theme;
            const isDarkMode = action.theme === Theme.DARK;
            const isDarkModeStorage = localStorage.getItem(PRE_AUTH_LOCAL_STORAGE_KEYS.isDarkMode) === "true";
            if (isDarkModeStorage !== isDarkMode)
                localStorage.setItem(PRE_AUTH_LOCAL_STORAGE_KEYS.isDarkMode, isDarkMode.toString());
            return Object.assign({}, state, { isDarkMode });
        default:
            return state;
    }
}

export const preAuthRootReducer = combineReducers({
    router: connectRouter(getHistory()),
    preAuth: preAuthReducer,
});
